const styles = theme => ({
  titleHead: {
    background: '#F8F8F8',
    color: '#342D3D',
    display: 'flex',
    padding: '10px 15px',
    [theme.breakpoints.up('md')]: {
      borderBottom: '1px solid #CED1D6',
    },
  },

  Title: {
    fontWeight: '600',
    marginBottom: '0',
    fontSize: '16px',
  },
  paperTitleBorder: {
    borderColor: '#CED1D6',
    borderTopWidth: '1px',
    borderBottomWidth: '1px',
    borderLeftWidth: '0',
    borderRightWidth: '0',
    borderStyle: 'solid',
  },
  ownerName: {},
  ownerDetails: {
    display: 'flex',
    width: '100%',
    padding: '20px 12px',
    '& div': {
      margin: '0 10px',
    },
    '& $ownerName': {
      fontStyle: 'normal',
      fontWeight: '600',
      fontSize: '18px',
    },
  },
  ownerAvatarimg: {
    height: '64px',
    width: '64px',
  },

  '@media (min-width: 960px)': {
    titleHead: {
      padding: '16px 24px',
    },
    Title: {
      fontSize: '1.25rem',
    },
  },
});

export default styles;
